import type { ErrorMap } from '@/app/error-registry';

/**
 * Error maps for the AI quick-create endpoints. Registered in the central
 * error registry so the URL pattern `/api/projects/{id}/boards/{id}/ai/tasks`
 * resolves before the generic `/api/projects/` catch-all (D5).
 *
 * Lookup order: backend error code -> HttpErrorType -> default.
 * Failure classes (R5): retryable, rephrase, not-permitted, empty-instruction,
 * default — each mapping to a distinct `ai:errors.*` key.
 */
export const AI_PROPOSE_ERROR_MAP: ErrorMap = {
  POST: {
    'Ai.ProviderUnavailable': 'ai:errors.retryable',
    'Ai.QuotaExceeded': 'ai:errors.retryable',
    'Ai.Uninterpretable': 'ai:errors.rephrase',
    'Ai.MissingData': 'ai:errors.rephrase',
    forbidden: 'ai:errors.notPermitted',
    validation: 'ai:errors.emptyInstruction',
    default: 'ai:errors.proposeDefault',
  },
};

export const AI_APPLY_ERROR_MAP: ErrorMap = {
  POST: {
    'ApplyQuickTask.AssigneeNotMember': 'ai:errors.assigneeNotMember',
    'ApplyQuickTask.StatusInvalid': 'ai:errors.statusInvalid',
    'ApplyQuickTask.GroupInvalid': 'ai:errors.groupInvalid',
    'ApplyQuickTask.EmptyPayload': 'ai:errors.emptyInstruction',
    'Task.TitleRequired': 'ai:errors.emptyInstruction',
    'Task.TitleTooLong': 'ai:errors.titleTooLong',
    'ApplyQuickTask.NoStatusAvailable': 'ai:errors.statusInvalid',
    forbidden: 'ai:errors.notPermitted',
    validation: 'ai:errors.emptyInstruction',
    default: 'ai:errors.applyDefault',
  },
};

export const AI_TASK_PLAN_PROPOSE_ERROR_MAP: ErrorMap = {
  POST: {
    'Ai.ProviderUnavailable': 'ai:errors.retryable',
    'Ai.QuotaExceeded': 'ai:errors.retryable',
    'Ai.Uninterpretable': 'ai:errors.rephrase',
    'Ai.MissingData': 'ai:errors.rephrase',
    forbidden: 'ai:errors.notPermitted',
    validation: 'ai:errors.emptyGoal',
    default: 'ai:errors.planProposeDefault',
  },
};

export const AI_TASK_PLAN_APPLY_ERROR_MAP: ErrorMap = {
  POST: {
    'TaskPlan.EmptySelection': 'ai:errors.emptySelection',
    'Task.TitleRequired': 'ai:errors.taskTitleRequired',
    'Task.TitleTooLong': 'ai:errors.titleTooLong',
    forbidden: 'ai:errors.notPermitted',
    validation: 'ai:errors.emptySelection',
    default: 'ai:errors.planApplyDefault',
  },
};
